<template>
    <v-card v-if="!$store.state.application.isConnected || !isSSOAllowed" class="elevation-12">
        <v-toolbar :color="loginColor" dark dense>
            <v-toolbar-title>{{ loginTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-4">
            <div v-if="!isSSOAllowed">
                <p>{{ ssoCheckMessage }}</p>
            </div>
            <div v-else>
                <p v-if="isSessionExpired">
                    Votre session à expirée, vous pouvez choisir de rester sur cette page ou vous pouvez vous reconnecter.
                </p>

                <ValidationObserver ref="observer">
                    <ValidationProvider v-slot="{ errors }" name="Client" rules="required">
                        <v-autocomplete v-show="$store.state.application.localEnv" v-model="providerCode" :items="providers"
                            placeholder="Client" prepend-icon="fas fa-users" menu-props="offsetY" :error-messages="errors"
                            outlined dense />
                    </ValidationProvider>

                    <v-row class="ml-4 mt-2">
                        <v-col class="ml-2 pt-0">
                            Votre identifiant correspond à l’adresse e-mail utilisée lors de votre réservation.
                        </v-col>
                    </v-row>
                    <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                        <v-text-field v-model="email" placeholder="Email" prepend-icon="fas fa-envelope"
                            @keydown.enter="submit" :error-messages="errors" outlined dense />
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Mot de passe" rules="required">
                        <v-text-field v-model="password" placeholder="Mot de passe" @keydown.enter="submit"
                            prepend-icon="fas fa-key" :type="showPassword ? 'text' : 'password'"
                            @click:append="showPassword = !showPassword"
                            :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'" :error-messages="errors"
                            outlined dense />
                    </ValidationProvider>
                </ValidationObserver>

                <v-row class="ml-4 no-gutters">
                    <v-col class="ml-5 pt-0">
                        <ForgottenPasswordModal :initEmail="email">
                            <template v-slot:activator="{ on }">
                                <a v-on="on"> Mot de passe oublié ? </a>
                            </template>
                        </ForgottenPasswordModal>
                    </v-col>
                </v-row>

                <v-row class="ml-4 mt-0" v-if="loginSubMessage">
                    <v-col class="ml-2 pt-0">
                        <small class="text-center align-self-center" v-html="loginSubMessage"></small>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-btn v-if="isSessionExpired" @click="$emit('close')" small> Rester </v-btn>

            <v-spacer />

            <v-btn v-if="isSSOAllowed" @click="submit()" :color="loginColor" dark small> Je me connecte </v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
import ForgottenPasswordModal from './ForgottenPasswordModal.vue';

export default {
    name: 'BuyerLoginCard',

    props: {
        isSessionExpired: { type: Boolean, default: false }
    },

    components: {
        ForgottenPasswordModal
    },

    data: () => ({
        isSSOAllowed: true,
        ssoCheckMessage: '',
        email: '',
        password: '',
        loginSubMessage: '',
        loginTitle: '',
        loginColor: '',

        showPassword: false,

        providers: []
    }),

    methods: {
        async submit() {
            try {
                const { client_id, redirect_uri, response_type, kc_idp_hint, scope, state, nonce } = this.$route.query;

                this.setLoading(true);
                const body = {
                    type: 'buyersso',
                    client_id,
                    redirect_uri,
                    response_type,
                    kc_idp_hint,
                    state, scope, nonce
                };
                const { success, err, auth_code, url } = await this.repos.auth.ssoLogin(body);
                
                
                if (success) {
                    this.$notify({
                        title: 'Bienvenue',
                        text: 'Bienvenue sur votre espace client',
                        type: 'success'
                    });

                    if (this.isSessionExpired) {
                        this.$emit('close');
                    } else {
                        if (success && auth_code && url) {
                            window.location.href = url;
                            window.location.replace(url);
                        }
                    }

                    
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: err.message,
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },
        async submit2() {
            try {
                const valid = await this.$refs.observer.validate();
                if (!valid) {
                    return;
                }

                this.setLoading(true);
                const body = {
                    type: 'buyer',
                    login: this.email,
                    password: this.password,
                    providerCode: this.providerCode
                };
                const { success, err } = await this.repos.auth.login(body);
                if (success) {
                    this.$notify({
                        title: 'Bienvenue',
                        text: 'Bienvenue sur votre espace client',
                        type: 'success'
                    });

                    if (this.isSessionExpired) {
                        this.$emit('close');
                    } else {
                        if (this.$route.query.redirect) {
                            this.$router.push({ path: this.$route.query.redirect, hash: this.$route.query.hash });
                        } else {
                            this.$router.push('/');
                        }
                    }
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: err.message,
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },

        async fetchProviders() {
            try {
                const {
                    providers
                } = await this.repos.providers.getAvailables();
                this.providers = providers;
            } catch (err) {
                console.error(err);
            }
        },

        async checkSSOAllowed() {
            try {
                const { client_id, redirect_uri, response_type, kc_idp_hint, scope, state } = this.$route.query;

                // Validate required query parameters
                if (!client_id || !redirect_uri || !response_type ||!scope) {
                    this.isSSOAllowed = false;
                    this.ssoCheckMessage = 'Paramètres de connexion manquants.';
                    return;
                }
                // Call the endpoint to check if SSO is allowed
                const { allowed, message } = await this.repos.auth.checkssoallowed({
                    client_id,
                    redirect_uri,
                    response_type,
                    kc_idp_hint,
                    providerCode: this.providerCode,
                    state, scope
                });

                this.isSSOAllowed = allowed;
                if (!allowed) {
                    this.ssoCheckMessage = message || 'Connexion non autorisée pour ce fournisseur.';
                }
            } catch (err) {
                console.error(err);
                this.isSSOAllowed = false;
                this.ssoCheckMessage = 'Erreur lors de la vérification de la connexion SSO.';
            }
        }
    },

    computed: {
        providerCode: {
            get() {
                return this.$store.state.application.providerCode;
            },

            set(providerCode) {
                this.$store.commit('application/setProviderCode', providerCode);
            }
        }
    },

    created() {
        this.checkSSOAllowed(); // Check SSO on page arrival
        if (this.$store.state.application.isConnected) {
            this.submit();
        } else {
            this.$router.replace({ path: '/connexion', query: this.$route.query });
        }
        this.fetchProviders();
        this.loginSubMessage = this.getConfig('login.sub_message', '');
        this.loginTitle = this.getConfig('login.title', '');
        this.loginColor = this.getConfig('login.color', '');
    }
};
</script>